import { render } from "./SelectedSessions.vue?vue&type=template&id=ae976036"
import script from "./SelectedSessions.vue?vue&type=script&lang=js"
export * from "./SelectedSessions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__